import React, { useState } from "react";
import Sidebar from "./sidebar/Sidebar";

function AdminProfile() {
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                My Profile
              </h1>
            </div>
            <div className="border mt-5 flex flex-col gap-16 justify-center items-center 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="flex justify-center items-center gap-4 ">
                <i className="fa-solid fa-circle-user text-[50px]"></i>
                <div>
                  <h4 className="font-semibold text-xl">Yogendra Panchal</h4>
                  <p className="text-xs text-[#757575]">yp@Renewcred.com</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-56">
                <div className="leading-10">
                  <p>Name</p>
                  <p>Email</p>
                  <p>Phone</p>
                  <p>Address</p>
                  <p>City</p>
                  <p>State</p>
                  <p>Pincode</p>
                </div>
                <div className="leading-10 text-[#757575]">
                  <p>Yogendra Panchal</p>
                  <p>yp@Renewcred.com</p>
                  <p>8460251079</p>
                  <p>Indiranager</p>
                  <p>Karnataka</p>
                  <p>Bangalore</p>
                  <p>560038</p>
                </div>
              </div>

              {/* <div>
                <p className="text-[#C65B1D]">change password</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminProfile;
